import { render, staticRenderFns } from "./CertificateForm.vue?vue&type=template&id=22e2bb78&scoped=true"
import script from "./CertificateForm.vue?vue&type=script&lang=js"
export * from "./CertificateForm.vue?vue&type=script&lang=js"
import style0 from "./CertificateForm.vue?vue&type=style&index=0&id=22e2bb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2bb78",
  null
  
)

export default component.exports